import React from 'react';
import './browse_filter.less';
import LocationAutoSearch from '../../components/location_auto_search/location_auto_search';
import validate from '../../util/validate';
import ReactRange from './browse_filter_range_component'
import PackageSizeDropdown from './package_size';
import CONSTANTS from '../../common_constants';
import BrowseDatePicker from './browse_date_picker.jsx';
import {commonFunctions} from '../browser_common.jsx';
import Checkbox from '../../components/checkbox/checkbox.jsx';
import MediaQuery from 'react-responsive';

class BrowseFilter extends React.Component{
  constructor(props){
    super(props);
    this.state = {
      browseFilter: this.props.browseFilter || {},
      currPopup: ''
    }

  }

  getLocationDetails = (inputFor, locationObj) =>{
    let browseFilter;


    if(inputFor == 'deliveryLocation'){
      browseFilter = Object.assign({}, this.state.browseFilter);

      if(locationObj != null){
        browseFilter.delivaryLat = locationObj.location.lat;
        browseFilter.delivaryLong = locationObj.location.lng;
        browseFilter.deliveryCountry= locationObj.countryCode;
        browseFilter.delivaryLocation = locationObj.label;
        this.setState({browseFilter});
        // api call via apply
        // this.props.updateParenStateCallback(this.state.browseFilter);
      }else{
        browseFilter.delivaryLat = '';
        browseFilter.delivaryLong = '';
        browseFilter.deliveryCountry= '';
        browseFilter.delivaryLocation = '';
        this.setState({browseFilter});
      }


      }

    else if(inputFor == 'pickupLocation'){
      browseFilter = Object.assign({}, this.state.browseFilter);

      if(locationObj != null){
        browseFilter.pickUpLat = locationObj.location.lat;
        browseFilter.pickUpLong = locationObj.location.lng;
        browseFilter.pickupCountry= locationObj.countryCode;
        browseFilter.pickupLocation = locationObj.label;
        this.setState({browseFilter});
        // api call via apply button
        // this.props.updateParenStateCallback(this.state.browseFilter);
      }else{
        browseFilter.pickUpLat = '';
        browseFilter.pickUpLong = '';
        browseFilter.pickupCountry= '';
        browseFilter.pickupLocation = '';
        this.setState({browseFilter});
      }

    }


  }

  handlePopupState = (currPopup) =>{
    const {state} = this;
    if(currPopup == ''){
      return;
    }
    if(state.currPopup == currPopup){
      this.setState({
        currPopup: ''
      })
    }
    else{
      this.setState({
        currPopup
      })
    }
  }

  updateParentState = (browseFilter) => {
    this.setState({
      browseFilter
    });
    // api call via apply button
    // this.props.updateParenStateCallback(browseFilter);
  }

  getTripValue = (value, id) =>{
    let browseFilter = Object.assign({}, this.state.browseFilter);
    browseFilter.isMyTrips = value;
    this.setState({browseFilter});
  }

  handleBodyClick = (e) => {
    if(e.target.matches('.filter-popup-parent') || e.target.matches('.filter-popup-parent') || e.target.matches('label') || e.target.matches('#offerStatus') ||  e.target.matches('.radio-button') || e.target.matches('.radio-button-option') || e.target.matches('.checkbox') || e.target.matches('.input-range__slider') || e.target.matches('.input-range__track') || e.target.matches('.icon-cross-feather') || e.target.matches('.radio-button-option-details')){
        // return;
    }
    else{
      this.setState({currPopup: ''});
    }
  }


  componentWillReceiveProps(newProps){
    let browseFilter = Object.assign({}, newProps.browseFilter);

    // if(!browseFilter.hasOwnProperty('deliveryLocation')){
    //   browseFilter.deliveryLocation = '';
    // }
    // if(!browseFilter.hasOwnProperty('pickupLocation')){
    //   browseFilter.pickupLocation = '';
    // }
    //
    this.setState({
      browseFilter
    });
  }

  componentDidMount(){
    // let browseFilter = Object.assign({}, this.props.browseFilter);
    // if(!browseFilter.hasOwnProperty('deliveryLocation')){
    //   browseFilter.deliveryLocation = '';
    // }
    // if(!browseFilter.hasOwnProperty('pickupLocation')){
    //   browseFilter.pickupLocation = '';
    // }
    // this.setState({browseFilter});
    document.body.addEventListener('click', this.handleBodyClick);
    document.body.addEventListener("touchstart", this.handleBodyClick);
    document.body.addEventListener("touchend", this.handleBodyClick);
    document.body.addEventListener("touchcancel", this.handleBodyClick);
    document.body.addEventListener("touchmove", this.handleBodyClick);
  }

  componentWillUnmount(){

    document.body.removeEventListener('click', this.handleBodyClick);
    document.body.removeEventListener("touchstart", this.handleBodyClick);
    document.body.removeEventListener("touchend", this.handleBodyClick);
    document.body.removeEventListener("touchcancel", this.handleBodyClick);
    document.body.removeEventListener("touchmove", this.handleBodyClick);
  }


  clearBrowseFilter = () =>{

    let browseFilter = Object.assign({}, this.state.browseFilter);

    if(commonFunctions.disableClear(browseFilter, true)){
      return;
    }else{
      browseFilter = commonFunctions.clearBrowseFilter(browseFilter);
    }

    // clear all browser filter
    this.props.clearBrowseFilterCallback(browseFilter);
  }

  applyToUpdateParentState = () => {
    let browseFilter = Object.assign({}, this.state.browseFilter);

      if(this.state.browseFilter.isMyTrips){
          browseFilter = commonFunctions.myTripHandleKeys(browseFilter);
      }
      
      this.props.updateParenStateCallback(browseFilter);

  }

  clearfields = (fieldName) => {
    let browseFilter = Object.assign({}, this.state.browseFilter);
    if(fieldName == 'range'){

      browseFilter.packageValueFrom = 0;
      browseFilter.packageValueTo = 10000;
      this.setState({browseFilter});

    }else if(fieldName == 'pickup' ){

      browseFilter.pickUpLat = '';
      browseFilter.pickUpLong = '';
      browseFilter.pickupCountry = '';
      browseFilter.pickupLocation = '';
      this.setState({browseFilter});

    }else if(fieldName == 'delivery'){

      browseFilter.delivaryLat = '';
      browseFilter.delivaryLong = '';
      browseFilter.deliveryCountry = '';
      browseFilter.delivaryLocation = '';
      this.setState({browseFilter});
    }
    else{
      browseFilter[fieldName] = '';
      this.setState({browseFilter});
    }

  }

  render(){
    const {props, state} = this;
    const self = this;
    const range = {min: 0, max: 10000, step: 100};
    let {currPopup} = state;
    let {browseFilter} = this.state;
    let packageSizeValue;
    let packageSize;
    let isMyTrips;
    (browseFilter.isMyTrips == undefined || browseFilter.isMyTrips == null) ? (isMyTrips = false) : (isMyTrips = browseFilter.isMyTrips);
    if(browseFilter == undefined || JSON.stringify(browseFilter) == '{}'){
      packageSize = -1;
      packageSizeValue = 'Package size'
    }else{
      (browseFilter.hasOwnProperty('packageSize')) ? (packageSize = browseFilter.packageSize) : (packageSize = -1);
      (CONSTANTS.packageSizeFilter[browseFilter.packageSize] != undefined) ? (packageSizeValue = CONSTANTS.packageSizeFilter[packageSize]) : (packageSizeValue = 'Package size');
    }
    return(
      <div id="browseFilterWrap">
        <div className="header" id="browseFilter">
          <div className="wrapper">
              <div className="location-wrap" id="myTrip">
                <div className="responsive-header-text">Filter packages by my trips</div>
                <span className="mytripText">My Trips</span>  <Checkbox status ={isMyTrips} handleChange = {this.getTripValue} id = {"offerStatus"}/>
              </div>
              <div className="location-wrap" id="locationAutoSaerchWrap">
                <div className="responsive-header-text">Pickup Location</div>
                <div className="location-elm">
                  <LocationAutoSearch disabled={browseFilter.isMyTrips} type="text" title="" value={validate.isEmpty(browseFilter.pickupLocation) ? "" : browseFilter.pickupLocation} placeholder = "Pickup Location" for = "pickupLocation" changeHandler = {this.getLocationDetails}/>
                  <span className="icon-icn_search"></span><span className="icon-cross-feather" onClick={this.clearfields.bind(self, 'pickup')}></span>
                </div>
                <MediaQuery query={'min-width: 1024px'}><div className="location-connector">to</div></MediaQuery>
                <div className="responsive-header-text">Delivery Location</div>
                <div className="location-elm">
                    <LocationAutoSearch disabled={browseFilter.isMyTrips} type="text" title="" value={validate.isEmpty(browseFilter.delivaryLocation) ? "" : browseFilter.delivaryLocation} placeholder = "Delivery Location" for = "deliveryLocation" changeHandler = {this.getLocationDetails}/>
                    <span className="icon-icn_search"></span><span className="icon-cross-feather" onClick={this.clearfields.bind(self, 'delivery')}></span>
                </div>

              </div>
              {<div className="filter-popup-wrap">
                <div className="responsive-header-text">Delivery Window</div>
                {<BrowseDatePicker disabled={browseFilter.isMyTrips} browseFilter={browseFilter} updateParentStateCallback={this.updateParentState} currState={'delivaryFrom'} placeholderText={'Travel start date'} /> }
                <span className="icon-cross-feather" onClick={this.clearfields.bind(self, 'delivaryFrom')}></span>
              </div> }
              <div className="filter-popup-wrap">
                {<BrowseDatePicker disabled={browseFilter.isMyTrips} browseFilter={browseFilter} updateParentStateCallback={this.updateParentState} currState={'delivaryTo'} placeholderText={'Travel end Date'} /> }
                 <span className="icon-cross-feather" onClick={this.clearfields.bind(self, 'delivaryTo')}></span>
              </div>
              <div className="filter-popup-wrap">
                <div className="responsive-header-text">Package Size</div>
                <div className="filter-popup-parent" onClick={this.handlePopupState.bind(self, 'size')} >{packageSizeValue}</div>
                {(currPopup == 'size') && <PackageSizeDropdown browseFilter={browseFilter} updateParentStateCallback={this.updateParentState} />}
                <span className="icon-cross-feather" onClick={this.clearfields.bind(self, 'packageSize')}></span>
              </div>
              <div className="filter-popup-wrap">
                <div className="responsive-header-text">Package Value</div>
                <div className="filter-popup-parent" onClick={this.handlePopupState.bind(self, 'price')} > ${browseFilter.packageValueFrom}&nbsp;-&nbsp;${browseFilter.packageValueTo}</div>
                {(currPopup == 'price') &&  <ReactRange range={range} browseFilter={browseFilter} updateParentStateCallback={this.updateParentState} /> }
                <span className="icon-cross-feather" onClick={this.clearfields.bind(self, 'range')}></span>
              </div>
              <div className="location-wrap">
                <div className="filter-button" onClick={this.applyToUpdateParentState}>Apply</div>
                <div className="filter-button" onClick={this.clearBrowseFilter}>Reset</div>
              </div>
          </div>
        </div>
      </div>
    )
  }

}

export default BrowseFilter



// WEBPACK FOOTER //
// app/browse_packages/browse_filter/browse_filter.jsx